/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_RelayInputs */



/**
* | output |
* | --- |
* | "This connection runs on a relay and can't be reconnected yet." |
*
* @param {Spaces_Credentials_RelayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_relay = /** @type {((inputs?: Spaces_Credentials_RelayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_RelayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Verbindung läuft über ein Relay und kann noch nicht neu verbunden werden.")
	return /** @type {LocalizedString} */ ("This connection runs on a relay and can't be reconnected yet.")
});